import { ProductsListState } from "./state";

function getRoot(state:any): ProductsListState {
    return state.reducer;
}

export function getSearchTerm(state: any) {
    const root = getRoot(state);
    return root.searchTerm;
}

export function getSelectedProductType(state: any) {
    const root = getRoot(state);
    return root.selectedProductType;
}

export function getFilteredData(state: any) {
    const root = getRoot(state);
    return root.filteredData;
}

export function getAccommodationProductsData(state:any){
    const root = getRoot(state);
    return root.accommodationProducts;
}

export function getCourseProductsData(state:any){
    const root = getRoot(state);
    return root.courseProducts;
}

export function getCourseById(state:any){
    const root = getRoot(state);
    return root.courseProduct;
}

export function getAccommodationById(state:any){
    const root = getRoot(state);
    return root.accommodation;
}

export function getTransferById(state:any){
    const root = getRoot(state);
    return root.transfer;
}

export function getAddonById(state:any){
    const root = getRoot(state);
    return root.addon;
}

export function getAddOnsProductsData(state:any){
    const root = getRoot(state);
    return root.addOnProducts;
}

export function getTransfersProductsData(state:any){
    const root = getRoot(state);
    return root.transferProducts;
}

export function getCourseIntensity(state:any){
    const root = getRoot(state);
    return root.courseIntensity;
}

export function getProductDivisions(state:any){
    const root = getRoot(state);
    return root.productDivisions;
}

export function getCourseName(state:any){
    const root = getRoot(state);
    return root.name;
}

export function getUpdatedCourseIntensityId(state:any){
    const root = getRoot(state);
    return root.intensityId;
}

export function getUpdatedCourseDivisionId(state:any){
    const root = getRoot(state);
    return root.divisionId;
}

export function getFormErrors(state: any){
    const root = getRoot(state);
    return root.formErrors;
}

export function getDraftAccommodationProduct(state: any) {
    const root = getRoot(state);
    return root.draftProduct;
}

export function getUnitTypes(state:any){
    const root = getRoot(state);
    return root.unitTypes;
}

export const getTypes = (state: any): { Id: number; Name: string }[] =>
    state.lookup?.types ?? [];
  
  export const getDivisions = (state: any): { Id: number; Name: string }[] =>
    state.lookup?.divisions ?? [];
  
export function getDraftAddOnProduct(state: any) {
    const root = getRoot(state);
    return root.draftAddOnProduct;
}

export function getAccommodationTypes(state:any){
    const root = getRoot(state);
    return root.accommodationTypes;
}

export function getTransferTypes(state: any) {
    const root = getRoot(state);
    return root.transferTypes;
}

export function getTransferPorts(state: any) {
    const root = getRoot(state);
    return root.transferPorts;
}

export function getDraftTransferProduct(state: any) {
    const root = getRoot(state);
    return root.draftTransferProduct;
}

export function getIntensityList(state: any) {
    const root = getRoot(state);
    return root.intensityList;
}

export function getIntensityLoading(state: any) {
    const root = getRoot(state);
    return root.intensityLoading;
}

export function getSchoolConfigs(state: any) {
    const root = getRoot(state);
    return root.schoolConfigs;
}

export function getSchoolConfigsLoading(state: any) {
    const root = getRoot(state);
    return root.schoolConfigsLoading;
}